'use strict';

exports.__esModule = true;

var _ramda = /*#__PURE__*/require('ramda');

/* eslint-disable max-len */
/**
 * Checks if value is `Date` object.
 *
 * @func isDate
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/0.6.0|v0.6.0}
 * @category Type
 * @sig * -> Boolean
 * @param {*} val The value to test
 * @return {boolean}
 * @see {@link RA.isNotDate|isNotDate}, {@link RA.isValidDate|isValidDate}, {@link RA.isNotValidDate|isNotValidDate}
 * @example
 *
 * RA.isDate(new Date()); //=> true
 * RA.isDate('1997-07-16T19:20+01:00'); //=> false
 */
/* eslint-enable max-len */
var isDate = /*#__PURE__*/(0, _ramda.is)(Date);

exports.default = isDate;


//////////////////
// WEBPACK FOOTER
// ./~/ramda-adjunct/lib/isDate.js
// module id = 276
// module chunks = 168707334958949